export const ALL_EMBED_JS = `query($filter: AbbvieProEmbedJsSnippetFilter, $first:Int, $last:Int, $after:Cursor, $before:Cursor){
      allAbbvieProEmbedJsSnippets(filter:$filter, first:$first, last:$last, after:$after, before:$before, orderBy: CREATED_AT_DESC){
        nodes{
          id
          embedJsKey
          embedJs
          demandNo
          modifiedBy: userByModifiedBy{
            firstName
            lastName
            email
          }
          publishStatus
          modifiedDate
          publishUpdateDate
          createdAt
          createdAtBy: userByUserId{
            firstName
            lastName
            email
          }
      }
      totalCount
      pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
}`;

export const CREATE_EMBED_JS = `mutation($embedJsSnippet: AbbvieProEmbedJsSnippetInput!){
  insertAbbvieProEmbedJsSnippet(input:{
    embedJsSnippet: $embedJsSnippet
  })
  {
    abbvieProEmbedJsSnippet{
      id
      embedJsKey
      embedJs
      demandNo
      modifiedBy: userByModifiedBy{
        firstName
        lastName
        email
      }
      publishStatus
      modifiedDate
      publishUpdateDate
      createdAt
      createdAtBy: userByUserId{
        firstName
        lastName
        email
      }
    }
  }
}`;

export const UPDATE_EMBED_JS = `mutation($embedJsSnippet: AbbvieProEmbedJsSnippetInput!){
  updateAbbvieProEmbedJsSnippetCustom(input:{
    embedJsSnippet:$embedJsSnippet
  }){
    abbvieProEmbedJsSnippet{
      embedJsKey
      embedJs
      demandNo
      publishStatus
      modifiedDate
      publishUpdateDate
      modifiedBy: userByModifiedBy{
        firstName
        lastName
        email
      }
      createdAtBy: userByUserId{
        firstName
        lastName
        email
      }
    }
  }
}`;

export const UPDATE_STATUS = `mutation($embedJsSnippet: UpdateStatusAbbvieProEmbedJsSnippetInput!){
  updateStatusAbbvieProEmbedJsSnippet(input:$embedJsSnippet)
  {
    boolean
  }
}`;

export const DELETE_EMBED_JS = `mutation($id: UUID!){
  deleteAbbvieProEmbedJsSnippetById(input:{
    id:$id
  })
  {
    abbvieProEmbedJsSnippet{
      id
    }
  }
}`;
